import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { Sparkles, TrendingUp, Award, Clock } from "lucide-react";

interface TreatmentsStepProps {
  form: UseFormReturn<any>;
}

const TreatmentsStep = ({ form }: TreatmentsStepProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-primary" />
          Trattamenti
        </h2>
        <p className="text-muted-foreground">Raccontaci dei tuoi trattamenti e dei risultati ottenuti</p>
      </div>

      <FormField
        control={form.control}
        name="mainTreatment"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Trattamento da Promuovere *</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Qual è il trattamento che desideri promuovere maggiormente?"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="treatmentReason"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Motivo della Promozione *</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Per quale motivo hai scelto questo trattamento?"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="differentiators"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Award className="w-4 h-4" />
              Cosa Ti Differenzia? Spiega cosa rende unico il tuo approccio *
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="In cosa i tuoi trattamenti si differenziano rispetto ai competitor?"
                className="resize-none min-h-[100px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="shortTermResults"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              Risultati Prima Seduta *
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder="Qual è stato il miglior risultato ottenuto dai tuoi clienti già alla prima seduta?"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="longTermResults"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Risultati Lungo Termine - Specifica risultati misurabili quando possibile</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Es. Perdita di 5kg in 8 settimane, riduzione macchie del 70% in 10 sedute..."
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="recommendations"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Raccomandazioni e Controindicazioni</FormLabel>
            <FormControl>
              <Textarea
                placeholder="A chi è consigliato e sconsigliato? (es. sconsigliato a donne in gravidanza...)"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="sessionDuration"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              Durata Seduta
            </FormLabel>
            <FormControl>
              <Input placeholder="Es. 45 minuti" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default TreatmentsStep;
